import { render, staticRenderFns } from "./FullView.vue?vue&type=template&id=52d65916&"
import script from "./FullView.vue?vue&type=script&lang=js&"
export * from "./FullView.vue?vue&type=script&lang=js&"
import style0 from "./FullView.vue?vue&type=style&index=0&id=52d65916&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports